import React from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { toastActions } from '../../actions/toast.actions'
import Yup from '../../helpers/custom-yup'
import { InvoiceService } from '../../services/invoice.service'
import { TextInput, EmailInput, PhoneInput, CEPInput, TextAreaInput } from '../../components/form-components/inputs.component'
import Button from '../../components/buttons/buttons.component'
import { StyledRegulation, FormGrid } from './invoice-request.page.styles'

const InvoiceRequestPage = ({ hideLoading, showLoading, toastSuccess, toastError }) => {

    const initialValues = {
        fullName: '',
        cpfCnpj: '',
        companyName: '',
        orderNumber: '',
        mobilePhone: '',
        buyerEmail: '',
        state: '',
        city: '',
        neighborhood: '',
        street: '',
        addressNumber: '',
        postalcode: '',
        observation: ''
    }
    const validationSchema = Yup.object().shape({
        fullName: Yup.string().name().required('Nome completo obrigatório'),
        cpfCnpj: Yup.string()
            .required('CPF ou CNPJ obrigatório')
            .test('cpfCnpj', 'CPF/CNPJ inválido', value => {
                if (!value) return false
                const digits = value.replace(/\D/g, '')
                if (digits.length === 11) {
                    const { validate } = require('../../services/cpf.service')
                    return validate(digits)
                }
                if (digits.length === 14) return true
                return false
            }),
        companyName: Yup.string().when('cpfCnpj', (cpfCnpj, schema) => {
            const digits = (cpfCnpj || '').replace(/\D/g, '')
            return digits.length === 14 ? schema.required('Razão Social obrigatória') : schema
        }),
        orderNumber: Yup.string().required('Número do Pedido obrigatório'),
        mobilePhone: Yup.string().cellphone().required('Telefone obrigatório'),
        buyerEmail: Yup.string().email('E-mail inválido').required('E-mail obrigatório'),
        state: Yup.string().required('Estado obrigatório'),
        city: Yup.string().required('Cidade obrigatória'),
        neighborhood: Yup.string().required('Bairro obrigatório'),
        street: Yup.string().required('Rua obrigatória'),
        addressNumber: Yup.string().residenceNumber().required('Número obrigatório'),
        postalcode: Yup.string().postalCode().required('CEP obrigatório'),
        observation: Yup.string().max(300, 'Observação deve ter no máximo 300 caracteres')
    })

    const onSubmit = (values, { resetForm }) => {

        showLoading()

        InvoiceService.create(values)
            .then((data) => {

                hideLoading()

                if (data && data.success) {
                    toastSuccess({ message: 'Solicitação enviada com sucesso.' })
                    resetForm()
                    return
                }
            })
            .catch(err => {
                hideLoading()
                const message = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao enviar solicitação.'
                toastError({ message })
            })
    }

    return (
        <Container style={{ paddingBottom: '5rem' }}>
            <Title>
                <span className="bold">Solicitação de Nota Fiscal</span>
            </Title>

            <StyledRegulation>
                <p>
                    Preencha os dados abaixo para solicitar a emissão da sua nota fiscal referente aos valores cobrados no seu pedido. Após o envio dos dados abaixo, a nota será emitida e encaminhada para o e-mail informado.
                </p>

                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                    {props => {
                        const { handleSubmit, values } = props
                        return (
                            <form onSubmit={handleSubmit}>
                                <FormGrid>
                                    <TextInput id="fullName" label="Nome completo" {...props} />
                                    <TextInput id="cpfCnpj" label="CPF ou CNPJ para faturamento" {...props} />
                                    <TextInput id="companyName" label="Razão Social (se CNPJ)" {...props} />
                                    <TextInput id="orderNumber" label="Número do pedido da compra da passagem" {...props} />
                                    <PhoneInput id="mobilePhone" label="Telefone" {...props} />
                                    <EmailInput id="buyerEmail" label="E-mail do recebedor da nota" {...props} />
                                    <TextInput id="state" label="Estado" {...props} />
                                    <TextInput id="city" label="Cidade" {...props} />
                                    <TextInput id="neighborhood" label="Bairro" {...props} />
                                    <TextInput id="street" label="Rua" {...props} />
                                    <TextInput id="addressNumber" label="Número" {...props} />
                                    <CEPInput id="postalcode" label="CEP" {...props} />
                                    <div>
                                        <TextAreaInput id="observation" label="Observação" maxLength={300} rows={4} {...props} />
                                        <div style={{ textAlign: 'right', fontSize: 12, color: (values && values.observation && values.observation.length >= 300) ? '#c62828' : '#666', marginTop: 6 }}>
                                            {((values && values.observation) ? values.observation.length : 0)}/300
                                        </div>
                                    </div>
                                </FormGrid>
                                <div style={{ marginTop: 20, display: 'flex', gap: 12 }}>
                                    <Button primary type="submit">Enviar</Button>
                                </div>
                            </form>
                        )
                    }}
                </Formik>
            </StyledRegulation>
        </Container>
    )
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            hideLoading: SiteCreators.hideLoading,
            showLoading: SiteCreators.showLoading,
            toastSuccess: toastActions.success,
            toastError: toastActions.danger
        },
        dispatch
    )

const connected = connect(null, mapDispatchToProps)(InvoiceRequestPage)

export { connected as ModuleRootComponent }

